import * as axios from "../../utilities/axios";

export const getAll = () => {
  return axios.basic
    .get(
      `${process.env.PARSE_DIR}/classes/TrafficState?keys=objectId,longName,shortName,available,prospect,affiliatedWithWinitLaw,isPQFlowEnabled`,
    )
    .then((res) => res.data.results)
    .catch(axios.parseError);
};
